<section class="ui-data-block tw:flex tw:flex-col tw:min-w-0 tw:pt-app-4"
  [class.ui-data-block--compact]="compact()">
  <ng-content select="[blockHeader]"></ng-content>
  <div class="ui-data-block__content tw:min-w-0">
    <ng-content></ng-content>
  </div>
</section>
